<template>
  <div>
    <form novalidate class="md-layout">
      <md-card class="" style="min-width:450px;">
        <md-card-header>
          <b-row>
            <b-col><div class="md-title">Contact Us</div></b-col>
            <b-col style="text-align:right">
              <md-button class="md-icon-button md-dense" @click="closeForm"><md-icon>highlight_off</md-icon></md-button>
            </b-col>
          </b-row>
        </md-card-header>
        <md-card-content>
          <md-field :class="{ 'md-invalid': inputSubjectErr }">
            <label>{{inputSubjectTitle}}</label>
            <md-input v-model="inputSubject"></md-input>
            <span class="md-error">{{inputSubjectErr}}</span>
          </md-field>

          <md-field :class="{ 'md-invalid': inputContentErr }">
            <label>{{inputContentTitle}}</label>
            <md-textarea v-model="inputContent"></md-textarea>
            <span class="md-error">{{inputContentErr}}</span>

          </md-field>
        </md-card-content>

        <md-card-actions>
          <md-progress-spinner v-if="loadingSubmit"  :md-diameter="30" :md-stroke="3" md-mode="indeterminate" style="color:white"></md-progress-spinner>
          <md-button v-else
            class="md-primary play-cta-button makeup"
            @click="submitForm()">{{contactSubmitBtnTxt}}</md-button>
        </md-card-actions>
      </md-card>
    </form>

  </div>
</template>

<script>
  import Snackbar from '../../components/snackbar.vue'
  import {submitSupportTicket} from '../../platform/support/services/supportService.js'
  export default {
    props: {
      inputSubjectTitle: {
        type: String,
        required: true
      },
      inputContentTitle: {
        type: String,
        required: true
      },
      inputSubjectOverwrite:{
        type: String,
        required: false
      }
    },
    components: {
      'error-snackbar': Snackbar
    },
    data() {
      return {
        inputSubject: "",
        inputContent: "",
        contactSubmitBtnTxt: "Submit",
        inputSubjectErr:"",
        inputContentErr:"",
        loadingSubmit: false
      }
    },
    computed: {
      currentUserEmail(){
        if(this.$store.getters.user) return this.$store.getters.user.email;
      }
    },
    watch: {
      inputSubject (newValue, oldValue) {
        if(newValue && newValue!=oldValue) this.inputSubjectErr=""
      },
      inputContent (newValue, oldValue) {
        if(newValue && newValue!=oldValue) this.inputContentErr=""
      }
    },
    created(){
      if(this.inputSubjectOverwrite) this.inputSubject = this.inputSubjectOverwrite
    },
    methods: {
      closeForm(){
        this.$emit('emitFinish', null)
      },
      submitForm(){
        if(this.validForm()){
          this.loadingSubmit=true
          submitSupportTicket({ subject:this.inputSubject, content:this.inputContent }, this.currentUserEmail)
            .then(resp => {
              this.$emit('emitFinish', true)
            })
            .catch(err => {
              this.$emit('emitFinish', false)
            })
            .finally(r => {this.loadingSubmit=false})
        }
      },
      validForm(){
        var result = true
        if (!this.inputSubject) {
          result = false
          this.inputSubjectErr="Required field"
        }
        if (!this.inputContent) {
          this.inputContentErr = "Required field"
          result = false
        }
        return result
      }
    }
  }
</script>
<style scoped>
  @import '../../assets/styles/dashboard.css';
  @import '../../assets/styles/global.css';
  @import '../../assets/styles/booking.css';
  @import '../../assets/styles/listings-view.css';

  .dead-booking{
    opacity: 0.5;
  }

  .booking-tenant-name{
    margin: 0 auto;
    margin-top: 1em;
    font-size: 18px;
    cursor: pointer;
    color: blue;
  }

  .booking-request-content-container{
    padding: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialogs/SupportForm.vue